/**
 * Utility to merge Tailwind classes with clsx + tailwind-merge (no conflicts).
 */
import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

/** Merges class names; later classes override earlier ones for Tailwind. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

